export default __webpack_public_path__ + "assets/345333307c21bbb38ae02dac93be2f5c.svg";